import React, { useEffect } from "react";
import './FeesAndCompensation.scss';

/**
FeesAndCompensationNew Component

Overview:

Details:
The component manages the rendering of the fees and compensation text, which can be dynamically fetched from an API or stored locally.
It may include sub-components for rendering specific sections or elements within the terms and conditions page, such as headings, paragraphs, or lists.
The component accepts props to customize the rendering of the terms and conditions content, such as font size, color, or alignment.
 */

export default function FeesAndCompensationNew ({ displayOnWebApp }) {

 
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const mailToInfoVedaslabs = (
    <a href="mailto:info@vedaslabs.io">
      <u>info@vedaslabs.io</u>
    </a>
  );

  const mailToTeamVedaslabsCapsText = (
    <a href="mailto:TEAM@VEDASLABS.IO">
      <u> TEAM@VEDASLABS.IO</u>
    </a>
  );

  const linkVedaslabsIo = (
    <a href="https://www.vedaslabs.io">
      <u> https://www.vedaslabs.io</u>
    </a>
  );

  const linkPrivacyPolicy = displayOnWebApp ? (
    <a href="https://vedaslabs.io/privacy-policy">
      <u> https://vedaslabs.io/privacy-policy</u>
    </a>
  ) : (
    <a href="https://vedaslabs.io/privacy-policy-page">
      <u> https://vedaslabs.io/privacy-policy</u>
    </a>
  );

    return (
    <div className="privacy-policy-content-block privacy-policy-content-block--terms">
      <p>
        You must read and agree to the following provisions before continuing with the electronic account opening and registration process for {linkVedaslabsIo} (the "Site").
      </p>

      <h5 className="heading">
        Disclosure of Promotional Fees Required for Offerings Conducted on the Site
      </h5>
      <p style={{fontStyle: 'italic'}}>
        (SEC Regulation Crowdfunding Rule 302(c))
      </p>
      <p>
        Investors participating in offerings on the Site should be aware that any individual or entity who promotes an offering for compensation—whether past or prospective—or who is a founder, officer, director, or employee of an issuer and engages in promotional communications about the offering must clearly disclose in all such communications:
      </p>
      <ol className="category-list">
        <li>
          that they are receiving compensation, and
        </li>
        <li>
          that they are acting as a promoter on behalf of the issuer.
        </li>
      </ol>
      <p>
        All such disclosures must be clear, prominent, and included within each promotional communication, whether on social media, email, or any other platform.
      </p>

      <h5 className="heading">
        Site Fees for Offerings and Sale of Securities Through the Site
      </h5>
      <p style={{fontStyle: 'italic'}}>
        (SEC Regulation Crowdfunding Rule 302(d))
      </p>
      <p>
        VedasLabs Inc. charges fees to issuers in connection with the posting of offerings and the sale of securities on the Site under Regulation Crowdfunding pursuant to Section 4(a)(6) of the Securities Act of 1933, as amended.
      </p>
      <p>
        Currently, the Site charges issuers:
      </p>
      <ul>
        <li>
          A one-time administrative fee of up to $5,000; and
        </li>
        <li>
          A transaction-based fee consisting of a commission of up to 7.0% of the amount raised in the offering, payable at the time of a successful closing and disbursement from escrow.
        </li>
      </ul>
      <p>
        The commission may be paid in cash and/or in the same securities offered to investors in the offering. Any securities accepted as compensation will be of the same class and have the same terms, conditions, and rights as those offered to the public. The Site may also be reimbursed for certain offering-related expenses, subject to a cap based on offering size.
      </p>
      <p>
        VedasLabs reserves the right to modify its fee structure at any time, including for promotional events, discounts, or new service offerings. Any such changes will take effect upon notice to users via updates to the Site and/or direct electronic communication. All fees paid to the Site are non-refundable unless otherwise determined by VedasLabs in its sole discretion.
      </p>

      <h5 className="heading">
        No Investment Advice
      </h5>
      <p>
        VedasLabs Inc. is not a registered broker-dealer or investment adviser. The Site does not provide investment advice, make investment recommendations, or advise on the raising of capital. No communication from the Site or its personnel should be construed as a recommendation or endorsement of any particular offering.
      </p>

      {/* Last Para */}
      <br />
      <p>Last updated: {displayOnWebApp ? "August 4th, 2025." : "August 4th, 2025."}</p>
      <p>&ldquo;VedasLabs&rdquo; is a trademark of VedasLabs Inc.</p>
    </div>
  );
};


